import { createSlice } from '@reduxjs/toolkit';
import { LevelStanding } from '@/core/interfaces';

interface LevelsStandingsState {
	standings: LevelStanding[];
}

const levelsSlice = createSlice({
	name: 'levelStandings',
	initialState: {
		standings: [],
	} as LevelsStandingsState,
	reducers: {
		setLevelsStandings: (state, action) => {
			state.standings = action.payload;
		},
	},
});

const { reducer, actions } = levelsSlice;

export const { setLevelsStandings } = actions;
export default reducer;
